import React from 'react'
import Modal from 'react-bootstrap/Modal'
import ClassEditor from 'components/Store/ClassEditor'
import {useRouteMatch} from 'util/router'

function AddClassModal(props) {

    const {show, onHide} = props

    return(
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            {...props}
            show={show}
            onHide={onHide}
            keyboard={false}
            backdrop={'static'}
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="container">
                    <ClassEditor 
                    newClass
                    onHide={onHide}
                    {...props}
                    />
                </div>
                
        </Modal>
    )
}

function NewClassButton(props) {

    const [open, setOpen] = React.useState(false)
 
    return (
        <div className={props.className}>
            <AddClassModal 
            {...props}
            show={open}
            onHide={() => setOpen(false)}
            />
            <button onClick={() => setOpen(true)} className="btn btn-primary">
                Add New
            </button>
        </div>
    );
}

export default NewClassButton